// styles
import classes from './styles.module.css';

export default function CustomButton({ text, onClick, children = null, disabled = false, className="" }) {
  return (
    <button 
      disabled={disabled}
      className={`${classes.root} ${className}`}
      onClick={onClick}
    >
      {text}
      {children && children}
    </button>
  )
}